import { Flex, getTheme, Modal, Space, Text } from '@conexasaude/conexa-hero'
import { Illustration } from '@conexasaude/iconography/illustrations'
import { useModalContext } from '../Modal/contexts/ModalContext'
import { SOSMentalHealthProps } from './types'
import { memo, useEffect } from 'react'
import { useSettingUpAnalyticsEvent } from '@/hooks/useSettingUpAnalytics'

export const SOSMentalHealth = memo(
  ({
    modalId,
    onRequestImmediateAttendance,
    isLoading = false,
  }: SOSMentalHealthProps) => {
    const theme = getTheme()
    const { closeModal, open } = useModalContext()
    const settingUpAnalyticsEvent = useSettingUpAnalyticsEvent()
    useEffect(() => {
      if (open !== modalId) return
      settingUpAnalyticsEvent({
        eventName: 'at_sos_mental_health_modal',
        interaction: 'seen',
      })
    }, [modalId, open, settingUpAnalyticsEvent])

    return (
      <Modal
        id={modalId}
        title="SOS Saúde Mental"
        opened={open === modalId}
        size={480}
        onClose={closeModal}
        primaryActionLabel={
          isLoading ? 'Enviando solicitação' : 'Solicitar agora'
        }
        primaryAction={onRequestImmediateAttendance}
        busyPrimaryAction={isLoading}
      >
        <Flex justify="center">
          <Illustration name="woman-confused" width={145} />
        </Flex>

        <Flex direction="column">
          <Text color={theme.colors.brand.primary[500]} variant="headingLarge">
            Precisa de ajuda imediata?
          </Text>
          <Space mt={theme.spacing.xs} />
          <Text variant="paragraphLarge">
            Se você está em sofrimento intenso, solicite agora o apoio imediato
            para um atendimento especializado. Você não está sozinho.
          </Text>
          <Space mt={theme.spacing.xs} />
          <Text variant="paragraphLarge">
            Se sua situação permite aguardar, recomendamos o agendamento de uma
            sessão de psicoterapia, onde você receberá o suporte adequado para
            sua jornada emocional.
          </Text>

          <Space mt={theme.spacing.xs} />

          <Text
            color={theme.colors.brand.primary[400]}
            variant="paragraphLarge"
            fontWeight={600}
          >
            Ao solicitar, você será direcionado para a fila de atendimento
            psicológico.
          </Text>
          <Space mt={theme.spacing.sm} />
        </Flex>
      </Modal>
    )
  },
)

SOSMentalHealth.displayName = 'SOSMentalHealth'
